export const environment = {
  production: true,
  BASE_DOMAIN:'https://ftl.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://ftl.apollosupplychain.com/',
   // AUTH_URL:'https://auth-dev.apollosupplychain.com/auth-service-common/',
  AUTH_URL:'https://ftl.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://ftl.apollosupplychain.com/',
  WebsocketUrl: 'wss://ftl.apollosupplychain.com/websocket-service/ws/notifications'
};
